(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .service('fromArrayToPathParam', fromArrayToPathParamService);

  /** @ngInject */
  function fromArrayToPathParamService() {
    this.createPath = function (array, property) {
      if (!array || array.length === 0) {
        return '&' + property + '';
      } else if (array.length === 1) {
        return '&' + property + array[0];
      } else {
        return array
          .reduce(function (total, current) {
            total.push('&' + property + current);
            return total;
          }, [])
          .toString()
          .split(',')
          .join('');
      }
    };

    this.createOnlyPath = function (array, property) {
      if (!array || array.length === 0) {
        return '?' + property + '';
      } else if (array.length === 1) {
        return '?' + property + array[0];
      } else {
        return array
          .reduce(function (total, current, index) {
            if (index === 0) {
              total.push('?' + property + current);
            } else {
              total.push('&' + property + current);
            }
            return total;
          }, [])
          .toString()
          .split(',')
          .join('');
      }
    };
  }
})();
